module.exports = __webpack_public_path__ + "img/generate_class.2fa55922.gif";